// extracted by mini-css-extract-plugin
export default {"root":"MoA1f","icon":"_25MFv","tooltip":"_2e5q6"};